/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_New_UserInputs */



/**
* | output |
* | --- |
* | "New User" |
*
* @param {User_List_New_UserInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_new_user = /** @type {((inputs?: User_List_New_UserInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_New_UserInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvel utilisateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo usuario")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Novo Usuário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo Utente")
	return /** @type {LocalizedString} */ ("New User")
});